module.exports = __webpack_public_path__ + "static/media/honeyComb.b454b080.png";